import { RecruteDetailData } from 'src/components/adminRecruit/useLoadRecruitSchedule';
import { create } from 'zustand';

type ModalType = 'BASIC' | 'CENTER' | 'BOTTOM' | null;

interface ModalState {
    type : ModalType
    title : string
    content : any
    footer : any
    width : string;
    open : boolean
    padding : string
    temporalState : boolean
    acceptAction: any;
    setAcceptAction: (action: any) => void;
    setField : (field: keyof ModalState, value: any) => void 
    reset : ()=>void
}

const defaultValue ={
    type : null,
    title : '',
    content : '',
    footer : '',
    width: 'auto',
    padding : '32px',
    open : false,
    temporalState: false,
    acceptAction: '',
}

export const useModalStore = create<ModalState>((set)=>({
    ...defaultValue,
    setAcceptAction: (action: any) => set({ acceptAction: action }),
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset: ()=>
        set(()=>({
            ...defaultValue
    }))
}))

export const useExtraModalStore = create<ModalState>((set)=>({
    ...defaultValue,
    setAcceptAction: (action: any) => set({ acceptAction: action }),
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset: ()=>
        set(()=>({
            ...defaultValue
    }))
}))





interface AdSheduleAddState{
    type : string
    title : string,
    certification : string,
    urlLink: string,
    etc : (string | null)[][];
    etcstartdate : string | null
    etcenddate : string | null
    recruitestartdate : string | null
    recruiteenddate : string | null
    startjob : string | null
    endjob : string | null
    ismodify : boolean
    returnData : RecruteDetailData | null
    idValue : number | null
    action : any
    setField : (field: keyof AdSheduleAddState, value: any) => void 
    reset : ()=>void
    addEtc: (newEtc: (string | null)[]) => void;
    updateEtc: (index: number, newEtc: (string | null)[]) => void;
    removeEtc: (index: number) => void; // ✅ 추가
}

const ModalAdSheduleAdddefault = {
    type : '부사관',
    title : '',
    certification:'',
    urlLink:'',
    etc: [] as string[][],
    etcstartdate : '',
    etcenddate: '',
    recruitestartdate : '',
    recruiteenddate : '',
    startjob : '',
    endjob : '',
    ismodify : false,
    returnData : null,
    idValue : null,
    action : {}
}

export const ModalAdSheduleAddStore = create<AdSheduleAddState>((set)=>({
    ...ModalAdSheduleAdddefault,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset: ()=>
        set(()=>({
            ...ModalAdSheduleAdddefault
    })),
    addEtc: (newEtc) => set((state) => ({
        etc: [...state.etc, newEtc],
    })),
    updateEtc: (index: number, newEtc: (string | null)[]) => 
    set((state) => {
        const updated = [...state.etc];
        updated[index] = newEtc;
        return { etc: updated };
    }),
    removeEtc: (index) =>
    set((state) => ({
        etc: state.etc.filter((_, i) => i !== index),
    })),
}));
